import { Component, OnInit } from '@angular/core';
import { User } from '../../_models/user';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss'],
})
export class WalletComponent implements OnInit {

  getCreditsData: any;
  getCreditsAmount: any;
  getCreditsReport: any;
  invoiceData: any;
  invoiceRecords: number;

  constructor(public user: User, private router: Router, private alertService: AlertService, private http: HttpClient, private g: Globals, private route: ActivatedRoute,
    private api: ApiIntegration) {
    this.getApi();
  }

  ngOnInit() { }


  creditReports() {
    this.router.navigate(['/admin/creditReports']);
  }


  getApi() {
    this.api.getCreditTransactions().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getCreditsData = data.creditTransactionslist;
    }, err => {
      this.alertService.error('Error', err);

    });
    this.api.getCreditTransactionAmount().subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getCreditsAmount = data;
    }, err => {
      this.alertService.error('Error', err);
      /*  this.alertService.errorTitle = "Error";
       this.alertService.errorMessage = err; */

    });
    this.api.getInvoicesByInvoiceType("CreditSale").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.invoiceRecords = data.noOfRecords;
      this.invoiceData = data.invoiceData;
    }, err => {
      this.alertService.error('Error', err);

    });
  }

}
